import { Component, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { CommonModule } from '@angular/common';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-filter-group-modal',
    templateUrl: './filter-group-modal.component.html',
    styleUrls: ['./filter-group-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RaCheckboxComponent,
        ButtonComponent,
    ]
})
export class FilterGroupModalComponent implements OnInit, OnDestroy, ModalChildComponent {

    parentComponent: ModalComponent;
    destroy$ = new Subject<void>();
    data: any;

    constructor(
        private filterEmitterService: FilterEmitterService
    ) { }

    ngOnInit() {
        this.filterEmitterService.watchFilter()
            .pipe(takeUntil(this.destroy$))
            .subscribe((facet) => this.setFacetGroupState(facet));

        // Avoid to close the filter drawer when the user interacts with the modal
        fromEvent(this.parentComponent.nativeElement, 'click')
            .pipe(takeUntil(this.destroy$))
            .subscribe(($event: MouseEvent) => $event.stopPropagation());
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onCheck(event: any, facet: Facet) {
        facet.value = event.detail.value;
        this.filterEmitterService.emitFilter(facet);
    }

    setFacetGroupState(facet: Facet) {
        this.data.facetGroups.forEach((facetGroup) => {
            this.setFacetState(facetGroup.facets, facet);
        });
    }

    setFacetState(facetList: Facet[], facet: Facet) {
        const myFacet = facetList.find(f => f.equal(facet));
        if (myFacet) {
            myFacet.value = facet.value;
        }
    }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
